































































































































































































import  { VNode, CreateElement } from 'vue';
import UUIFComponent from '@/shared/uuifComponent';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwFileUpload } from '@libs-uuif/shared/sw-file-upload';
import { envCongif } from '@/shared/env.config';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { TableColumnConfig, TableEntry } from '@libs-uuif/shared/sw-table';
import { multiServiceActivationTab } from '@/modules/msw-products';
const cssPrefix = 'bulkactivation';
@Component({
  components:{
    ...UUIFComponent,
    SwFileUpload,
  },
  directives: {
    tooltip,
  },
})

export default class BulkActivation extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  openBulkActivationDialog: boolean;
  files:File[] = [];
  bulkactData:any = [];
  bulkactRespData:any = [];
  status:any = [];
  result:any = [];
  pendingKeyIndex:any = [];
  screen:string = '1';
  filename:string = '';
  errorMsg:string = '';
  errorFlag:boolean = false;
  needUpdateType:boolean = false;
  showStatus:boolean = false;
  currentStep:string = 'uploadStep';
  enableActivationButton: boolean = false;
  serviceActivationTableConfig: TableColumnConfig[] =
    [{
      key: 'Serial',
      dataKey: 'Serial',
      sorter: true,
      width: 130,
      title: (this.$t('bulkact.serial')
      .toString()),
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
                 <div>
                      { this.serialNumberRender(h, data) }
                 </div>
          ) as VNode;
      },
    },
    {
      key: 'actkey',
      dataKey: 'actkey',
      sorter: true,
      width: 130,
      title: (this.$t('bulkact.activationkey')
      .toString()),
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {  // tslint:disable-line
        return (
              <div>
               {this.activationKeyColumnRender(h, data)}
               </div>
        ) as VNode;
      },
    },
    {
      key: 'endDate',
      dataKey: 'EndDate',
      sorter: true,
      width: 100,
      title: (this.$t('bulkact.enddate')
      .toString()),
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {  // tslint:disable-line
        return (
              <div> {  data.entry.endDate ?   data.entry.endDate : '--'  } </div>
        ) as VNode;
      },
    },
    {
      key: 'status',
      dataKey: 'status',
      sorter: true,
      width: 310,
      title: (this.$t('bulkact.status')
      .toString()),
      className: `${cssPrefix}__statusColumn`,
      render: (h:CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
            <div>
               {this.statusColumnRender(h, data)}
            </div>
        ) as VNode;
      },
    },
    ];
  activationKeyColumnRender(h: CreateElement, data: { entry: TableEntry }) {  // tslint:disable-line
    const rowCol:any[] = [];
    data.entry
    .activationKey.split(',')
    .forEach((element:any) => {
      rowCol.push(<div> {element} </div>);
    });
    if (data.entry
    .activationKey.split(',').length > 1) {
      rowCol.push(<br/>);
    }
    return rowCol;
  }
  serialNumberRender(h: CreateElement, data:{ entry: TableEntry }) { // tslint:disable-line
    const cell:any[] = [];
    cell.push(<span> { data.entry.serialnumber } </span>);
    if (data.entry.status === 'pending') {
      cell.push(<span class="bulkactivation__TableError">*</span>);
    }
    return cell;
  }
  statusColumnRender(h: CreateElement, data: { entry: TableEntry }) {  // tslint:disable-line
    console.warn(data.entry);
    const cell:any[] = [];
    switch (data.entry.status) {
      case 'valid':  cell.push(<span> { data.entry.message }  </span>);
        break;
      case 'invalid':  cell.push(<span class="bulkactivation__TableError"> { data.entry.message }  </span>);
        break;
      case 'pending':  cell.push(<div> { this.statusPendingRender(h, data) } </div>);
        break;
    }
    return cell;
  }
  statusPendingRender(h: CreateElement, data: { entry: TableEntry }) {  // tslint:disable-line
    const cell:any[] = [];
    cell.push(
        <table class={`${cssPrefix}__statusColumn--tableClass`}>
            <thead>
             <tr class={`${cssPrefix}__statusColumn--headerClass`}>
                <th class={`${cssPrefix}__statusColumn--radioClass`}><span class="bulkactivation__addSpace"></span></th>
                <th class={`${cssPrefix}__statusColumn--serviceNameClass`}><span>{this.$t('bulkact.service')}</span></th>
                <th class={`${cssPrefix}__statusColumn--clientlicenseClass`}><span>{this.$t('bulkact.clientlic')}</span></th>
                <th class={`${cssPrefix}__statusColumn--expiryDateClass`}><span>{this.$t('bulkact.expir')}</span></th>
             </tr>
             </thead>
            <tbody>
                {this.serviceRowRender(h, data)}
            </tbody>
        </table>,
    );
    cell.push(<br/>);
    return cell;
  }
  serviceRowRender(h:CreateElement, data: { entry:TableEntry }) { // tslint:disable-line
    const cell:any = [];
    data.entry.arrPostActivation.forEach((service:any , index : any) => {
      switch (service.status) {
        case undefined :
          switch (index === 0) {
            case true :
              cell.push(
            <tr  class={`${cssPrefix}__statusColumn--rowClass`}>
             <td  class={`${cssPrefix}__statusColumn--radioClass`}><span class="bulkactivation__addSpace">
                <input type="radio" name={data.entry.name} value={service.UpdateType} checked/>
             </span></td>
            <td class={`${cssPrefix}__statusColumn--serviceNameClass`}><span>{service.ServiceName}</span></td>
            <td class={`${cssPrefix}__statusColumn--clientlicenseClass`}><span>{service.NoOfnodes}</span></td>
            <td class={`${cssPrefix}__statusColumn--expiryDateClass`}><span>{service.ExpirDate}</span></td>
            </tr>);
              break;
            case false :
              cell.push(
            <tr  class={`${cssPrefix}__statusColumn--rowClass`}>
             <td class={`${cssPrefix}__statusColumn--radioClass`}><span class="bulkactivation__addSpace">
                <input type="radio" name={data.entry.name} value={service.UpdateType}/>
             </span></td>
            <td class={`${cssPrefix}__statusColumn--serviceNameClass`}><span>{service.ServiceName}</span></td>
            <td class={`${cssPrefix}__statusColumn--clientlicenseClass`}><span>{service.NoOfnodes}</span></td>
            <td class={`${cssPrefix}__statusColumn--expiryDateClass`}><span>{service.ExpirDate}</span></td>
            </tr>);
              break;
          }
          break;
        default:cell.push(<td><span class="bulkactivation__TableError">{service.status}</span></td>);
          break;
      }
    });
    return cell;
  }
  get statusData() {
    const data: TableEntry[] = [];
    let rowData: any[] = [];
    if (this.currentStep === 'validateStep') {
      rowData =  [...this.bulkactData];
    } else {
      rowData =  [...this.bulkactRespData];
    }
    rowData.forEach((entry: any, index: any) => {
      const newEntry: TableEntry = Object.assign({}, entry);
      newEntry._key = index.toString();
      newEntry._selectable = false;
      data.push(newEntry);
    });
    return data;
  }
  @Watch('files')
  private onFileSelect() {
    if (this.files.length > 0) {
      if (this.files[0].name.split('.')
                        .pop() === 'csv') {
        if (this.files[0].name.length > 30) {
          this.filename = this.files[0].name;
          this.filename = `${this.filename.substring(0, 29)}...`;
        } else {
          this.filename = this.files[0].name;
        }
      } else {
        this.filename = '';
        this.errorMsg =   (this.$t('bulkact.error2')
        .toString());
      }
    }
  }
  close() {
    this.screen = '1';
    this.$emit('closeDialog');
  }
  downloadSample(num:Number) {
    let url = '';
    if (num === 1) {
      url = `${envCongif.contemporary_url}/profile/act_bulk.csv`;
    } else if (num === 2) {
      url = `${envCongif.contemporary_url}/profile/act_bulkMKeys.csv`;
    }
    window.location.replace(url.replace('/muir', ''));
  }

  submitBulkActivation() {
    debugger;
    this.needUpdateType = false;
    const arrMultiKeyActivation:any[] = [];
    this.bulkactData.forEach((item:any) => {
      const obj:any = { serialnumber: item.serialnumber , activationKey: item.activationKey , endDate: item.endDate , messageAccept: '', actionType: '' };
      arrMultiKeyActivation.push(obj);
    });
    const request:any = {
      arrMultiKeyActivation,
      mode: this.currentStep === 'validateStep' ? 'preview' : 'force',
    };
    this.bulkactRespData = [];
    this.status = [];
    this.result = [];
    this.$store.dispatch('MswProductsStoreModule/multiactivation', request)
        .then((response:any) => {
          this.$store.commit('stopLoading');
          debugger;
          if (response.operationStatus === 'OK') {
            this.status = response.arrActivateServiceStatus ? response.arrActivateServiceStatus : [];
            this.result = response.arrMultiKeyActivationResult ? response.arrMultiKeyActivationResult : [];
            this.showStatus = true;
            let i = 0;
            if (response.msgCode === 'MSWAPP:SUCCESS') {
              this.currentStep = 'finalStep';
              this.showStatus = true;
            } else {
              this.currentStep = 'activationStep';
              this.screen = '2';
            }
            if (response.isActivationEnabled && response.isActivationEnabled === true) {
              this.enableActivationButton = true;
            }
            this.status.forEach((item:any) => {
              i += 1;
              if (item.status === 'invalid') {
                const data = {
                  serialnumber: item.serialnumber,
                  activationKey: item.activationKey,
                  endDate: item.endDate,
                  status: 'invalid',
                  message: item.errorMessage,
                };
                this.bulkactRespData.push(data);
              }
              if (item.status === 'valid') {
                if (item.arrPostActivation === undefined) {
                  const data = {
                    serialnumber: item.serialnumber,
                    activationKey: item.activationKey,
                    endDate: item.endDate,
                    status: 'valid',
                    message: this.result && this.result.length > 0 ?
                             this.result.filter((key:any) => key.activationKey === item.activationKey)[0].message :
                             item.status,
                  };
                  this.bulkactRespData.push(data);
                } else {
                  const data = {
                    serialnumber: item.serialnumber,
                    activationKey: item.activationKey,
                    endDate: item.endDate,
                    status: 'pending',
                    arrPostActivation: item.arrPostActivation,
                    name : `service${i}`,
                  };
                  this.needUpdateType = true;
                  this.pendingKeyIndex.push(i - 1);
                  this.bulkactRespData.push(data);
                }
              }
            });
            this.screen = '2';
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
          }
        });
  }

  submitPendingBulkActivation() {
    this.needUpdateType = false;
    const arrMultiKeyActivation:any[] = [];
    this.bulkactRespData.forEach((item:any) => {
      if (item.status === 'pending') {
        const ele = document.querySelector(`input[name="${item.name}"]:checked`) as HTMLInputElement ;
        const obj = {
          serialnumber: item.serialnumber,
          activationKey: item.activationKey,
          endDate: item.endDate,
          messageAccept: 'YES',
          actionType: ele.value,
        };
        arrMultiKeyActivation.push(obj);
      } else {
        const obj = {
          serialnumber: item.serialnumber,
          activationKey: item.activationKey,
          endDate: item.endDate,
          messageAccept: '',
          actionType: '',
        };
        arrMultiKeyActivation.push(obj);
      }
    });
    const request = {
      arrMultiKeyActivation,
      mode: 'force',
    };
    console.warn(request);
    this.$store.dispatch('MswProductsStoreModule/multiactivation', request)
      .then((response:any) => {
        if (response.operationStatus === 'OK') {
          const status = response.arrActivateServiceStatus;
          const result = response.arrMultiKeyActivationResult;
          let i = -1;
          if (response.msgCode === 'MSWAPP:SUCCESS') {
            this.currentStep = 'finalStep';
            this.showStatus = true;
          }
          status.forEach((item:any) => {
            i += 1;
            if (item.status === 'invalid') {
              const data = {
                serialnumber: item.serialnumber,
                activationKey: item.activationKey,
                endDate: item.endDate,
                status: 'invalid',
                message: item.errorMessage,
              };
              const index = this.pendingKeyIndex[i];
              this.bulkactRespData[index] = data;
            }
            if (item.status === 'valid') {
              const data = {
                serialnumber: item.serialnumber,
                activationKey: item.activationKey,
                endDate: item.endDate,
                status: 'valid',
                message: result.filter((key:any) => key.activationKey === item.activationKey)[0].message,
              };
              const index = this.pendingKeyIndex[i];
              this.bulkactRespData[index] = data;
            }
          });
          const tempData = this.bulkactRespData;
          this.bulkactRespData = [];
          tempData.forEach((ele :any) => {
            this.bulkactRespData.push(ele);
          });
          this.screen = '2';
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
        }
        this.$store.commit('stopLoading');
      });
  }

  processFile() {
    debugger;
    this.bulkactData = [];
    this.errorMsg = '';
    const fileReader = new FileReader();
    fileReader.readAsText(this.files[0]);
    fileReader.onload = (e:any) => {
      const fileContents = e.currentTarget['result']!;
      const fileTextLines = fileContents.split(/\r\n|\n/);
      let startIndex;
      if (fileTextLines[0].indexOf('SERIALNUMBER') === -1) {
        startIndex = 0;
      } else {
        startIndex = 1;
      }
      const header = fileTextLines[0].split(',');
      for (let i = startIndex; i < fileTextLines.length; i += 1) {
        if (fileTextLines[i] !== '') {
          const data = fileTextLines[i].split(',');
          const inner: any = {};
          inner['SERIALNUMBER'] = data[0].trim();
          let keys = '';
				  let expDate =  ''; // tslint:disable-line
          for (let k = 1 ; k < data.length; k += 1) {
            const actkey = data[k].replace(/"/g, '')
                           .trim();
            if (k === 1) {
              keys = `${actkey}`;
            } else if (actkey.length > 0 && header.length === 2) {
              keys = `${keys},${actkey}`;
            } else if (header.length > 2) {
              expDate = actkey;
            }
          }
          inner['ACTIVATIONKEY'] = keys;
          if (expDate && expDate.length > 0) {
            inner['ENDDATE'] = expDate;
          } else {
            inner['ENDDATE'] = '';
          }
          this.bulkactData.push(inner);
        }
      }
      this.bulkactData = this.bulkactData.filter((ele: any) => ele.SERIALNUMBER !== '' || ele.ACTIVATIONKEY !== '');
      if (this.bulkactData.length > 0) {
        this.currentStep = 'validateStep';
        this.bulkactData.map((item :any) => {
          item.serialnumber = item.SERIALNUMBER;
          item.activationKey = item.ACTIVATIONKEY;
          item.endDate = item.ENDDATE;
          item.messageAccept = '';
          item.actionType = '';
          delete item.SERIALNUMBER;
          delete item.ACTIVATIONKEY;
          delete item.ENDDATE;
        });
        this.screen = '2';
      } else {
        this.errorMsg = (this.$t('bulkact.emptycsv')
        .toString());
      }
    };
  }
  onSubmit() {
    if (this.files.length === 0) {
      this.errorMsg =  (this.$t('bulkact.error1')
      .toString());
      this.errorFlag = true;
    } else if (this.files[0].name
                            .split('.')
                            .pop() !== 'csv') {
      this.errorMsg =   (this.$t('bulkact.error2')
      .toString());
    } else {
      this.processFile();
    }
  }
  gotoStatus() {
    this.close();
    // this.$store.dispatch('navigateTo', 'ui/bulkactivationstatus');
    this.$router.push({ path: `/m/feature/${multiServiceActivationTab.path}` });
  }
  get setDynamicWidth() {
    if (this.screen === '1') {
      return '600px';
    }
    return '750px';
  }
}
